
import Vue from 'vue'
export default Vue.extend({
  name: 'DocumentLink',
  props: {
    url: {
      type: String,
      required: true
    },
    target: {
      type: String,
      default: '_blank'
    },
    text: {
      type: String,
      default: 'Document'
    }
  }
})
